import React, { useState } from "react";
import "./Header.css";
import Logo from "./../img/bwp zoo logo web page.png";
import menu from './../img/menu.png'

export default function Header() {
  const [menuActive, setMenuActive] = useState(false)
  const [homeActive, setHomeActive] = useState(true)
  const [visitActive, setVisitActive] = useState(false)
  const [galleryActive, setGalleryActive] = useState(false)
  const [exploreActive, setExploreActive] = useState(false)
  const [contactActive, setContactActive] = useState(false)

  // conditions for active link
  const homeHandler = () => {
    setMenuActive(false)
    setHomeActive(true)
    setVisitActive(false)
    setGalleryActive(false)
    setExploreActive(false)
    setContactActive(false)
  }
  const visitHandler = () => {
    setMenuActive(false)
    setHomeActive(false)
    setVisitActive(true)
    setGalleryActive(false)
    setExploreActive(false)
    setContactActive(false)
  }
  const galleryHandler = () => {
    setMenuActive(false)
    setHomeActive(false)
    setVisitActive(false)
    setGalleryActive(true)
    setExploreActive(false)
    setContactActive(false)
  }
  const exploreHandler = () => {
    setMenuActive(false)
    setHomeActive(false)
    setVisitActive(false)
    setGalleryActive(false)
    setExploreActive(true)
    setContactActive(false)
  }
  const contactHandler = () => {
    setMenuActive(false)
    setHomeActive(false)
    setVisitActive(false)
    setGalleryActive(false)
    setExploreActive(false)
    setContactActive(true)
  }
  return (
    <div className="header">
      <div className="header-center">
        <div className="bottom-pattern"></div>
        <img src={Logo} alt="logo" className="logo"/>
        <div className="links">
          <li onClick={homeHandler}>
            <a href="#home" className={homeActive ? 'activeLink' : null}>Home</a>
          </li>
          <li onClick={visitHandler}>
            <a href="#planeYourVisit" className={visitActive ? 'activeLink' : null}>visit Plan</a>
          </li>
          <li onClick={galleryHandler}>
            <a href="#gallery" className={galleryActive ? 'activeLink' : null}>Gallery</a>
          </li>
          <li onClick={exploreHandler}>
            <a href="#library" className={exploreActive ? 'activeLink' : null}>Explore</a>
          </li>
          <li onClick={contactHandler}>
            <a href="#contact" className={contactActive ? 'activeLink' : null}>contact us</a>
          </li>
        </div>
        <img src={menu} alt="menu" className="menu" onClick={()=>setMenuActive(!menuActive)}/>
      </div>
      {/* -----for responsive header */}
      <div className={menuActive ? 'links-block showMenu':'links-block'}>
        <li onClick={homeHandler}>
          <a href="#home" className={homeActive ? 'activeLink' : null}>Home</a>
        </li>
        <li onClick={visitHandler}>
          <a href="#planeYourVisit" className={visitActive ? 'activeLink' : null}>visit Plan</a>
        </li>
        <li onClick={galleryHandler}>
          <a href="#gallery" className={galleryActive ? 'activeLink' : null}>Gallery</a>
        </li>
        <li onClick={exploreHandler}>
          <a href="#library" className={exploreActive ? 'activeLink' : null}>Explore</a>
        </li>
        <li onClick={contactHandler}>
          <a href="#contact" className={contactActive ? 'activeLink' : null}>contact us</a>
        </li>
      </div>
    </div>
  );
}
